import { css } from 'styled-components';

// Naming Convention: [size: [xs/sm/md/lg/xl]] + [weight: light/normal/bold/bolder]

export const baseFont = css`
  font-family:
    'JakartaSans',
    -apple-system,
    Helvetica,
    Arial,
    sans-serif;
  font-style: normal;
  line-height: 124%;
  text-decoration: none;
`;

// Light

export const xxsLight = css`
  ${baseFont}
  font-weight: 400;
  font-size: 12px;
`;

export const xsLight = css`
  ${baseFont}
  font-weight: 400;
  font-size: 13px;
`;

export const smLight = css`
  ${baseFont}
  font-weight: 400;
  font-size: 14px;
`;

export const mdLight = css`
  ${baseFont}
  font-weight: 400;
  font-size: 16px;
`;

// Regular

export const xxxxsRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 8px;
`;

export const xxxsRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 10px;
`;

export const xxsRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 12px;
`;

export const xsRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 13px;
`;

export const smRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 14px;
`;

export const mdRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 16px;
`;

export const lgRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 18px;
`;

export const xxlRegular = css`
  ${baseFont}
  font-weight: 500;
  font-size: 24px;
`;

// Bold

export const xxxxsBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 10px;
`;
export const xxsBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 12px;
`;

export const xsBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 13px;
`;

export const smBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 14px;
`;

export const mdBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 16px;
`;

export const lgBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 18px;
`;

export const xlBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 20px;
`;

export const xxlBold = css`
  ${baseFont}
  font-weight: 600;
  font-size: 26px;
`;
